<template>
	<div id="anatomyReportDialog" class="modal" tabindex="-1" role="dialog" aria-labelledby="anatomyReportDialogTitle"
		aria-hidden="true">
		<div class="modal-dialog modal-dialog-centered modal-sm" role="document">
			<form class="modal-content dialog-content">
				<div class="modal-body wizard-body">
					<h5 class="modal-title wizard-title" id="anatomyReportDialogTitle">
						Anatomy Change Report
					</h5>
					<button type="button" class="close" data-dismiss="modal" aria-label="Close"
						style="z-index: 9; width: 30px;">
						<span aria-hidden="true">&times;</span>
					</button>
					<div class="container-fluid">
						<div id="reportAnchorageLossDiv" class="mb-3">
							<label class="form-label" for="reportAnchorageLossCb">
								<input type="checkbox" class="form-check-input" id="reportAnchorageLossCb"
									v-model="isAnchorageLoss">Min
								Anchorage Loss(%):</label>
							<input v-model="anchorageLoss" type="number" class="form-control" v-on:keydown.stop
								:disabled="!isAnchorageLoss">
						</div>
						<div class="mb-3">
							<label for="reportAngulationCb" class="form-label"><input type="checkbox"
									class="form-check-input" id="reportAngulationCb" v-model="isAngulation">Min
								Angulation Angle:</label>
							<input v-model="angulationAngle" type="number" class="form-control" v-on:keydown.stop
								:disabled="!isAngulation">
						</div>
						<div class="mb-3">
							<label for="reportCollisionCb" class="form-label"><input type="checkbox"
									class="form-check-input" id="reportCollisionCb" v-model="isCollision">Min
								Collision Area(mm2):</label>
							<input v-model="collisionArea" type="number" class="form-control" v-on:keydown.stop
								:disabled="!isCollision">
						</div>
					</div>
				</div>
				<div class="modal-footer wizard-footer">
					<button type="button" class="btn btn-primary btn-next" aria-label="OK"
						v-on:click="anatomyChangeReportClick()">
						OK
					</button>
				</div>
			</form>
		</div>
	</div>
</template>

<script>
import swal from "sweetalert";
import { createAnatomyChangeReport } from "./OrtoReporting";

export default {
	name: "anatomyReportDialog",
	props: ["mode"],
	data() {
		return {
			isAnchorageLoss: true,
			isAngulation: true,
			isCollision: true,
			anchorageLoss: 1,
			angulationAngle: 10,
			collisionArea: 1
		};
	},
	methods: {
		anatomyChangeReportClick: async function () {
			$("#anatomyReportDialog").modal("hide");
			let reportSetups = {
				isAnchorageLoss: this.isAnchorageLoss,
				isAngulation: this.isAngulation,
				isCollision: this.isCollision,
				anchorageLoss: +this.anchorageLoss,
				angulationAngle: +this.angulationAngle,
				collisionArea: +this.collisionArea,
			};
			createAnatomyChangeReport(reportSetups);
		}
	}
};

</script>

<style scoped>
@import "@/css/wizard.css";

/* #reportAnchorageLossDiv {
	display: none;
} */

.form-label {
	margin-left: 25px;
}

#anatomyReportDialogTitle {
	position: absolute;
	left: calc(50% - 125px);
	top: 12px;
}

.container-fluid {
	margin-top: 30px;
}

.modal-sm {
	max-width: 500px;
	text-align: left;
}

.container-group {
	border: 2px solid #d7dee5;
	border-radius: 0.25rem;
	margin: 30px 0 20px 0;
	padding: 10px 0 4px 0;
	justify-content: space-between;
}

.form-check {
	margin-left: 0.5rem;
	margin-right: 0.5rem;
	max-width: calc(100% - 35px);
}

.form-check-label {
	display: inline-block;
	width: calc(100% + 25px);
}

.modal-header {
	height: 60px;
}

.modal-title {
	max-width: 270px;
	left: 45px;
	/* calc(50% - 55px); */
}

.modal-body {
	padding-top: 30px;
	padding-left: 15px;
	padding-right: 15px;
}

.close {
	margin-right: -10px;
	margin-top: -20px;
}
</style>